<template>
  <div v-if="isLoading" class="flex h-screen items-center justify-center bg-gray-50">
    <div class="text-center">
      <p class="text-gray-500 text-lg animate-pulse">正在驗證權限，請稍候...</p>
    </div>
  </div>

  <div v-else class="flex flex-col gap-6 p-4 sm:p-6">
    <section class="card">
      <MerchantUserPage :userApi="accountApi" />
    </section>

    <section class="card">
      <MerchantInfoEditCard :merchantTzApi="tzApi" />
    </section>

    <section class="card">
      <TzSettingCard :merchantTzApi="tzApi" />
    </section>

    <section class="card">
      <ChangePasswordPage :changePasswordApi="accountApi" />
    </section>

    <section class="card">
      <MerchantKeysPage :merchantKeysApi="merchantKeysApiImpl" />
    </section>

    <section class="card">
      <BlogPostPage :blogPostApi="blogApi" />
    </section>

    <section class="mb-10">
      <h3 class="text-gray-400 text-sm font-bold mb-4">危險區域</h3>

      <UserSecurityPanel :userSecurityApi="userSecurityApiImpl" @onLogoutRequired="handleAppLogout" />
    </section>

    <p class="text-sm text-gray-700">v0.0.0.16</p>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue' // 👈 記得引入 ref
import {
  ChangePasswordPage, MerchantUserPage, UserSecurityPanel,
  MerchantKeysPage,
} from '@myorg/account-lib'
import { BlogPostPage } from '@myorg/blog-lib'
import { logger } from '@myorg/type-lib'
import { TzSettingCard, MerchantInfoEditCard } from '@myorg/menu-editor-lib'
import {
  blogApi, accountApi, tzApi,
  userSecurityApiImpl, merchantKeysApiImpl
} from './useUserServices'
import { useRouter } from 'vue-router'
import { handleAuthSuccess } from '@/api/auth'
import { redirectToClientLogin } from '@/auth/authRedirect'

const router = useRouter()

// 💡 新增：管理載入狀態，預設為 true (鎖定狀態)
const isLoading = ref(true)

const handleAppLogout = () => {
  localStorage.removeItem('token')
  localStorage.removeItem('refresh_token')
  redirectToClientLogin()
}

onMounted(async () => {
  await router.isReady()
  const currentPath = router.currentRoute.value.path

  if (currentPath !== '/login' && currentPath !== '/account-privacy') {
    try {
      // 💡 確實等待 API 回傳，並把資料寫入 localStorage
      await handleAuthSuccess()

      // 🎉 成功後才放行！解開鎖定，這時子元件才會開始執行它們的 onMounted
      isLoading.value = false

    } catch (err) {
      logger.error('驗證流程發生錯誤，細節:', err);
      logger.log('Session 無效，引導至登入流程')
      localStorage.clear()
      redirectToClientLogin()
      // 這裡不用將 isLoading 設為 false，因為網頁馬上就要被導走了
    }
  } else {
    // 如果是公開頁面，不需驗證，直接放行
    isLoading.value = false
  }
})
</script>